import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CategoryCard from "./CategoryCard";
import { useProducts } from "../../../contexts/Products";
import { useServices } from "../../../contexts/Services";
import Tabs from "../../../components/controls/Tabs";

const CategorySelection = ({
  nextStep,
  updateEventData,
  eventData,
  goToPreviousStep,
}) => {
  const { t } = useTranslation();
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [activeTab, setActiveTab] = useState("products");

  const products = useProducts("products");
  const services = useServices("services");

  const tabs = [
    { id: "products", label: t("categorySelection.productsTab") },
    { id: "services", label: t("categorySelection.servicesTab") },
  ];

  const handleCategorySelect = (id, type) => {
    if (type === "products") {
      setSelectedProducts((prev) =>
        prev.includes(id) ? prev.filter((n) => n !== id) : [...prev, id]
      );
      updateEventData({ selectedProducts: [...selectedProducts, id] });
    } else if (type === "services") {
      setSelectedServices((prev) =>
        prev.includes(id) ? prev.filter((n) => n !== id) : [...prev, id]
      );
      updateEventData({ selectedServices: [...selectedServices, id] });
    }
  };

  return (
    <div className="flex flex-col items-center w-full px-6">
      <h2 className="text-3xl font-extrabold text-gray-800 mb-4">
        {t("categorySelection.title")}
      </h2>
      <p className="text-gray-600 text-center mb-6 max-w-3xl">
        {t("categorySelection.description")}
      </p>
      <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />

      {/* Grille des catégories */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full px-6 mb-6">
        {(activeTab === "products" ? products : services).map((category) => (
          <CategoryCard
            key={category.id}
            category={category}
            title={t(`${category.name}`)}
            description={category.description}
            isSelected={
              activeTab === "products"
                ? selectedProducts.includes(category.id)
                : selectedServices.includes(category.id)
            }
            onSelect={() =>
              handleCategorySelect(
                category.id,
                activeTab === "products" ? "products" : "services"
              )
            }
          />
        ))}
      </div>

      <div className="mt-6 flex justify-between gap-x-4 w-1/2">
        {/* Bouton Retour */}
        <button
          onClick={goToPreviousStep}
          className="w-1/2 bg-muted text-white py-3 rounded-full hover:bg-gray-300 transition focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2"
        >
          {t("stepTwo.buttons.back")}
        </button>

        {/* Bouton Suivant */}
        <button
          onClick={nextStep}
          className="w-1/2 bg-primary text-white py-3 rounded-full hover:bg-primary/90 transition focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
        >
          {t("stepOne.nextButton")}
        </button>
      </div>
    </div>
  );
};

export default CategorySelection;
